import React, { useCallback, useEffect, useMemo } from 'react';
import { Tabs as TabsStyle, Tab, TabLabel } from '@Calix-Commerce/design-system/components';

function Tabs({ selected, children, onChange }) {
  const [display, setDisplay] = React.useState(selected || 0);
  const tabs = useMemo(
    () =>
      children &&
      React.Children.toArray(children)
        .filter((child) => child.props.label && child.props.children)
        .map((child) => child.props),
    [children]
  );

  useEffect(() => {
    setDisplay(selected);
  }, [selected]);

  useEffect(() => {
    if (display !== selected && typeof onChange === 'function') {
      onChange(display);
    }
  }, [display]);

  const selectTab = useCallback(
    (tab, index) => {
      typeof tab.onClick === 'function' && tab.onClick();
      setDisplay(index);
    },
    [display]
  );

  return (
    <>
      {tabs.length > 1 && (
        <TabsStyle>
          {tabs &&
            tabs.map((tab, index) => (
              <Tab
                key={tab.label}
                selected={display === index}
                onClick={() => selectTab(tab, index)}
              >
                <TabLabel>{tab.label}</TabLabel>
              </Tab>
            ))}
        </TabsStyle>
      )}
      {tabs[display]?.children}
    </>
  );
}

export default Tabs;
